module.exports = __webpack_public_path__ + "static/media/tv.24a23a65.svg";